import {
  CHANGE_LOG_ACTIONS,
  CHANGE_LOG_FIELDS,
  SUCCESSION_NAVIGATION_ITEMS,
  SUCCESSION_USER_STATUSES,
} from 'constants/succession';

export const prepareReadinessLevelOptions = readinessLevels =>
  (readinessLevels || []).filter(readinessLevel => readinessLevel?.is_active);

export const prepareRemovalReasonOptions = removalReasons =>
  (removalReasons || []).filter(
    removalReason => removalReason?.is_active && !removalReason?.is_system
  );

export const prepareChangeLogEntryCreator = (labels, entry, renderUser) => {
  if (entry?.actor_is_system) return labels.system;

  return entry?.actor ? renderUser(entry.actor) : '-';
};

const getUpdatedActionLabel = (actionLabels, field) => {
  if (field === CHANGE_LOG_FIELDS.READINESS) {
    return actionLabels.updatedReadiness;
  }
  if (field === CHANGE_LOG_FIELDS.NOTE) {
    return actionLabels.updatedNote;
  }
  return null;
};

const withEmployeeAction = (entry, renderChangeLogEntryAction, actionLabel) => {
  if (!actionLabel) return '-';

  return renderChangeLogEntryAction(entry?.employee, actionLabel);
};

export const prepareChangeLogEntryAction = (
  labels,
  entry,
  renderChangeLogEntryAction
) => {
  const actionLabels = labels.changelogActions || {};

  switch (entry?.action) {
    case CHANGE_LOG_ACTIONS.ADDED:
      return withEmployeeAction(
        entry,
        renderChangeLogEntryAction,
        actionLabels.added
      );
    case CHANGE_LOG_ACTIONS.UPDATED:
      return withEmployeeAction(
        entry,
        renderChangeLogEntryAction,
        getUpdatedActionLabel(actionLabels, entry?.field)
      );
    case CHANGE_LOG_ACTIONS.REMOVED:
      return withEmployeeAction(
        entry,
        renderChangeLogEntryAction,
        actionLabels.removed
      );
    case CHANGE_LOG_ACTIONS.RANK_CHANGED:
      return withEmployeeAction(
        entry,
        renderChangeLogEntryAction,
        actionLabels.rankChanged
      );
    case CHANGE_LOG_ACTIONS.KEY_SET:
      return actionLabels.keySet || '-';
    case CHANGE_LOG_ACTIONS.KEY_UNSET:
      return actionLabels.keyUnset || '-';
    default:
      return '-';
  }
};

export const prepareSuccessionTableActionColumn = label => [
  {
    id: 'actions-column',
    title: label,
    rowKey: 'actions',
    align: 'right',
    rowCellClass: 'actions-cell',
    isHeaderAction: true,
    isSortingDisabled: true,
    minWidth: 72,
    maxWidth: 96,
  },
];

export const prepareSuccessionNavigationItems = labels =>
  SUCCESSION_NAVIGATION_ITEMS.flatMap(item => {
    return [
      {
        key: item.key,
        url: item.url,
        end: item.end,
        name: labels[item.translationKey],
      },
    ];
  });

export const isSuccessionUserRemoved = memberStatus =>
  memberStatus === SUCCESSION_USER_STATUSES.REMOVED;
